import React from 'react';
import { defineMessages } from 'react-intl';

import PrivacyPolicy from 'components/PrivacyPolicy';
import Page from 'components/Pages/container';
import { TermsIcon } from 'components/Icons';
import { Container } from '../TermsAndConditions/styles';

const messages = defineMessages({
  title: {
    defaultMessage: 'Privacy Policy',
  },
});

export default () => (
  <Page settingsPage={true} titleMessage={messages.title} Icon={TermsIcon}>
    <Container>
      <PrivacyPolicy />
    </Container>
  </Page>
);
